module.exports = __webpack_public_path__ + "static/caddy-impression-54298e7577805eefe55c91f37c8b93a7.png";